import React from "react";
import styled from "styled-components";
import {HeaderPageSection} from "../../elements/PageSection";
import PageHeading from "../../elements/PageHeading";
import {subduedTextColour} from "../../../style/styleConsts";
import {DeactivatedLabel} from "./DeactivatedLabel";
import {AuthorFunction} from "./AuthorFunction";
import {AuthorLocation} from "./AuthorLocation";
import {AuthorEmail} from "./AuthorEmail";
import {AuthorPhone} from "./AuthorPhone";

const CompanyName = styled.div`
    font-weight: bold;
    font-size: 16px;
`;

const AuthorName = styled.div`
    display: inline-block;
    margin-right: 20px;
`;


const ContactDetailsContainer = styled.div`
    display: flex;
    align-items: center;
    font-size: 14px;
    color: ${subduedTextColour};
    margin-top: 10px;
`;

export const AuthorPageHeader = ({authorDetails}) => {
    const {companyName, authorName, active} = authorDetails;
    return <HeaderPageSection>
        <CompanyName className="t-company-name">{companyName}</CompanyName>
        <PageHeading>
            <AuthorName className="t-name">{authorName}</AuthorName>
            <DeactivatedLabel active={active}/>
        </PageHeading>

        <ContactDetailsContainer>
            <AuthorFunction authorDetails={authorDetails}/>
            <AuthorLocation authorDetails={authorDetails}/>
            <AuthorEmail authorDetails={authorDetails}/>
            <AuthorPhone authorDetails={authorDetails}/>
        </ContactDetailsContainer>
    </HeaderPageSection>;
};